// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"1":"877cd600d0707572a488","963":"7d59942bada114501013"}[chunkId] + ".bundle.js";
};